export function getSupabaseAuthErrorMessage(error, fallback) {
  if (error instanceof Error) {
    if (error.message.includes('Invalid login credentials')) {
      return 'The email or password is incorrect.';
    }
    if (error.message.includes('User already registered')) {
      return 'An account already exists for this email address. Try signing in instead.';
    }
    return error.message;
  }
  return fallback;
}
